import { createFileRoute } from '@tanstack/react-router'
import TermsConditionsPage from '@/pages/TermsConditionsPage'

export const Route = createFileRoute('/terms-conditions')({
  component: TermsConditionsPage,
})
